import JudgeItem from './JudgeItem';

export default JudgeItem;
